import { Shield } from '@lyra/core/components/Icon'
import Tag from '@lyra/core/components/Tag'
import Tooltip from '@lyra/core/components/Tooltip'
import { YieldTokenConfig, YieldTokenId } from '@lyra/web/constants/yield'
import { formatTokenSymbol } from '@lyra/web/utils/tokens'
import { getYieldTokenConfig } from '@lyra/web/utils/yield'

type Props = {
  yieldId: YieldTokenId
  isLarge?: boolean
}

const getTooltipCopy = (config: YieldTokenConfig) => {
  switch (config.strategyId) {
    case 'CoveredPutSpread':
    case 'CoveredCallSpread':
      return `If ${config.marketId} goes ${
        config.strategyId === 'CoveredCallSpread' ? 'above' : 'below'
      } the target price on a given week, a portion of your ${formatTokenSymbol(
        config.collateralId
      )} is sold for USDC. The amount sold cannot exceed 3% of the initial deposit.`
    case 'LongPrincipalProtected':
      return `This vault is principal protected, meaning you always get back your initial ${formatTokenSymbol(
        config.collateralId
      )} deposit.`
    case 'CoveredCalls':
      return `If ${
        config.marketId
      } goes above the target price on a given week, a portion of your ${formatTokenSymbol(
        config.collateralId
      )} is sold for USDC.`
    case 'BasisTrade':
      return 'This vault can withstand 10x rallies and 99% drawdowns in price as it retains delta-1 exposure.'
  }
}

const getTooltipTitle = (config: YieldTokenConfig) => {
  switch (config.strategyId) {
    case 'CoveredPutSpread':
    case 'CoveredCallSpread':
      return 'Limited Downside'
    case 'LongPrincipalProtected':
      return 'Principal Protected'
    case 'CoveredCalls':
      return 'Partial Principal'
    case 'BasisTrade':
      return 'Liquidation Protected'
  }
}

const getIcon = (config: YieldTokenConfig) => {
  switch (config.strategyId) {
    case 'CoveredPutSpread':
    case 'CoveredCallSpread':
    case 'LongPrincipalProtected':
    case 'BasisTrade':
      return <Shield />
    case 'CoveredCalls':
      return null
  }
}

export const YieldRiskTag = ({ yieldId, isLarge }: Props) => {
  const config = getYieldTokenConfig(yieldId)
  return (
    <Tooltip
      title={getTooltipTitle(config)}
      content={getTooltipCopy(config)}
      trigger={
        <Tag
          cursor="help"
          icon={getIcon(config)}
          isLarge={isLarge}
          label={getTooltipTitle(config)}
        />
      }
    />
  )
}
